import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {ConfigService} from "../config/config.service";
import {Perfil} from "../types/Perfil.type";
import {Funcao} from "../types/Funcao";

@Injectable({
  providedIn: 'root'
})
export class FuncaoService {

  constructor(private httpClient: HttpClient, private configService: ConfigService) { }

  getFuncoes(){
    return this.httpClient.get<Funcao[]>(`${this.configService.getApiUrl()}/funcoes`);
  }

  getFuncao(id: string){
    return this.httpClient.get<Funcao>(`${this.configService.getApiUrl()}/funcoes/${id}`);
  }

  postFuncao(funcao: Funcao){
    return this.httpClient.post<Funcao>(`${this.configService.getApiUrl()}/funcoes`, funcao);
  }

  putFuncao(funcao: Funcao){
    return this.httpClient.put<Funcao>(`${this.configService.getApiUrl()}/funcoes`, funcao);
  }

 getFuncoesPorPerfil(idsPerfis: any[]){
    return this.httpClient.post<Funcao[]>(`${this.configService.getApiUrl()}/funcoes/por-perfis`, idsPerfis);
 }
}
